module.exports = __webpack_public_path__ + "static/media/off-day-icon.cf3da2ec.png";